import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import { Auth, Credentials } from 'common/logic/Auth'

interface Props {
    loginCallback: (username: string) => void
}

function LoginForm({ loginCallback }: Props) {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [isChecking, setIsChecking] = useState(false)

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault()
        if (!username || !password || isChecking) return
        setIsChecking(true)
        const credentials = new Credentials(username, password)
        Auth.validateCredentials(credentials)
            .then(response => {
                if (response) {
                    setIsChecking(false)
                    Auth.setCredentials(credentials)
                    loginCallback(username)
                }
            })
            .catch(() => {
                setIsChecking(false)
            })
    }

    return (
        <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formEmail">
                <Form.Label>Username</Form.Label>
                <Form.Control
                    type="text"
                    name="username"
                    placeholder="Username"
                    onChange={e => setUsername(e.target.value)}
                    disabled={isChecking}
                />
            </Form.Group>
            <Form.Group controlId="formPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                    type="password"
                    name="password"
                    placeholder="Password"
                    onChange={e => setPassword(e.target.value)}
                    disabled={isChecking}
                />
            </Form.Group>
            <Button variant="primary" type="submit" disabled={isChecking}>
                {isChecking
                    ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    : <span>Submit</span>}
            </Button>
        </Form>
    )
}

export default LoginForm
